import { combineReducers, Reducer } from 'redux';
import { reducer as fullReducer } from 'b2b-apps/shop/product/redux/products/full/reducer';
import { reducer as tileReducer } from 'b2b-apps/shop/product/redux/products/tile/reducer';
import { ProductsActions, ProductsState } from './types';

const reducer: Reducer<ProductsState, ProductsActions> = combineReducers({
  full: fullReducer,
  tile: tileReducer,
});

export { reducer };
